import axios from 'axios'
import i18n from '@/plugins/i18n'

export default {
  // Получение данных отчета ООПТ
  getReportOopt (id) {
    return axios.get(`${i18n.locale}/api/report/getReportOopt/${id}`)
  },
  // Получение данных ячеек отчета ООПТ
  getReportOoptData (id) {
    return axios.get(`${i18n.locale}/api/report/getReportOoptData/${id}`)
  },
  // Сохранение данных отчета
  saveData (id, partId, data) {
    return axios.post(`${i18n.locale}/api/report/save/${id}/${partId}`, data)
  },
  // Список действий
  getActions (statusId) {
    return axios.get(`${i18n.locale}/api/report/actions/${statusId}`)
  },
  // Изменение статуса
  changeStatus (id, data) {
    return axios.post(`${i18n.locale}/api/report/changeStatus/${id}`, data)
  },
  // Список
  list (filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined) {
        filter += `${field}=${filters[field]}&`
      }
    }
    return axios.get(`${i18n.locale}/api/report/list?${filter}`)
  },
  // Список отчетов по текущему пользователю
  listReportByOopt (id) {
    return axios.get(`${i18n.locale}/api/report/reportListByOopt/${id}`)
  },
  // Данные для формы создания отчета ООПТ
  getFormData () {
    return axios.get(`${i18n.locale}/api/report/formData`)
  },
  // Создание отчета ООПТ
  create (data) {
    return axios.post(`${i18n.locale}/api/report/create`, data)
  },
  // список отчетов
  formReports () {
    return axios.get(`${i18n.locale}/api/report/form_reports`)
  },
  // список отчетов, организаций, справочник года
  getGenerateFormData () {
    return axios.get(`${i18n.locale}/api/summaryReport/getFormData`)
  },
  // генерация отчета
  getGeneratedReportData (reportId, yearId, filters) {
    let filter = ''

    for (const field in filters) {
      if (filters[field] !== undefined && (field !== 'word' || (field === 'word' && filters[field] === true))) {
        filter += `${field}=${filters[field]}&`
      }
    }
    let config = {}
    if (filters.word && filters.word === true) {
      config = { responseType: 'arraybuffer' }
    }
    return axios.get(`${i18n.locale}/api/summaryReport/getReportData/${reportId}/${yearId}?${filter}`, config)
  },
  // список ООПТ для сводных отчетов в форме
  getOoptDataBySoateAndType (soateId, ooptTypeId) {
    let filter = ''
    if (ooptTypeId !== undefined) {
      filter = `ooptType=${ooptTypeId}`
    }
    return axios.get(`${i18n.locale}/api/summaryReport/getOoptDataBySoateAndType/${soateId}?${filter}`)
  },
  // список участков для сводных отчетов в форме
  getObservePlotByOoptAndYear (ooptId, yearId) {
    let filter = ''
    if (yearId !== undefined) {
      filter = `year=${yearId}`
    }
    return axios.get(`${i18n.locale}/api/summaryReport/getObservePlotByOoptAndYear/${ooptId}?${filter}`)
  }
}
